import { Config } from '../types';

export const config = {
  defaultLocale: 'en-US',
  supportedLocales: ['en-US', 'sr-Latn'],
  supportedFlags: ['flagpack:us', 'flagpack:rs'],
  defaultCountryCode: 'RS',
} satisfies Config;

export default config;
